import { Outlet, useLocation } from 'react-router-dom';
// @mui
import { Container, Stack } from '@mui/material';
// components
import Page from 'src/components/Page';
import HeaderBreadcrumbs from 'src/components/HeaderBreadcrumbs';
import { merchantStatsMenu } from './dashboard/navbar/NavConfig';
import ProgramTopNavWrapper from './dashboard/navbar/ProgramTopNavWrapper';

const MerchantStatsLayout: React.FC<{ currentPath: string }> = ({ currentPath }) => {
  const { pathname } = useLocation();

  const currentLocation = merchantStatsMenu?.[0]?.children?.find((el) => el?.path === pathname);

  return (
    <Page title={currentPath}>
      <Container maxWidth={false}>
        <HeaderBreadcrumbs
          links={[
            { name: merchantStatsMenu?.[0].title },
            { name: currentLocation?.title || '' },
          ]}
        />

        <Stack direction={'column'} spacing={1}>
          <ProgramTopNavWrapper
            navigation={merchantStatsMenu?.[0]?.children}
            showDatePicker={true}
          />

          <Outlet />
        </Stack>
      </Container>
    </Page>
  );
};

export default MerchantStatsLayout;
